import React, { useContext, useEffect, useState } from 'react'
import AdminSideBar from '../../components/adminSideBar/AdminSideBar'
import { EnvoieContext } from '../../context/envoieContext/EnvoieContext'
import FormInput from '../../components/formInput/FormInput';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import { getCosts, simulateGetCost, updateCosts, updateCostsEntreprise } from '../../context/envoieContext/apiCalls';
import { clientsOrEntreprises, communes, pricesClientsAndEntreprises, typeDeliveries, typeEnvois, typeRamassages, wilayas } from '../../data';
import FormRadio from '../../components/formRadio/FormRadio';
import './cost.css';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import { getEntreprisesMini } from '../../context/entrepriseContext/apiCalls';
import { EntrepriseContext } from '../../context/entrepriseContext/EntrepriseContext';

function Cost() {
    const { dispatch, costs, costsentreprise, isFetchingCosts, errorCosts, isFetchingSimulate, cost, isFetchingCostsUpdate, errorCostsUpdate, mess } = useContext(EnvoieContext);
    const { dispatch: dispatchEntreprise, entreprisesMini } = useContext(EntrepriseContext);
    const [errorBox, setErrorBox] = useState("");
    const [priceClientsAndEntreprises, setPriceClientsAndEntreprises] = useState(pricesClientsAndEntreprises[1]);

    const [typeEnvoie, setTypeEnvoie] = useState(typeEnvois[0]);
    const [typeClient, setTypeClient] = useState(clientsOrEntreprises[1]);
    const [entreprise, setEntreprise] = useState({ nom: "Choisir Entreprise", id: 0, })
    const [typeDelivery, setTypeDelivery] = useState(typeDeliveries[0]);
    const [typeRamassage, setTypeRamassage] = useState(typeRamassages[0]);
    const [wilayaSender, setWilayaSender] = useState(wilayas[0]);
    const [wilayaReceiver, setWilayaReceiver] = useState(wilayas[0]);

    const [weight, setWeight] = useState("");
    const [result, setResult] = useState("");

    useEffect(() => {
        getEntreprisesMini(dispatchEntreprise);
        getCosts(dispatch);
    }, [])

    useEffect(() => {
        getCosts(dispatch);
    }, [mess])

    useEffect(() => {
        if (costs.length !== 0) {
            /******* First Line *******/
            setC1c1(`${costs[0]['cout']}`);
            setC1c2(`${costs[1]['cout']}`);
            setC1e2(`${costs[2]['cout']}`);
            setC1e3(`${costs[3]['cout']}`);
            setC1o2(`${costs[4]['cout']}`);
            setC1o3(`${costs[5]['cout']}`);
            setC1s4(`${costs[6]['cout']}`);
            setC1s5(`${costs[7]['cout']}`);

            /******* Second Line *******/
            setC2c1(`${costs[8]['cout']}`);
            setC2c2(`${costs[9]['cout']}`);
            setC2e2(`${costs[10]['cout']}`);
            setC2e3(`${costs[11]['cout']}`);
            setC2o2(`${costs[12]['cout']}`);
            setC2o3(`${costs[13]['cout']}`);
            setC2s4(`${costs[14]['cout']}`);
            setC2s5(`${costs[15]['cout']}`);

            /******* Third Line *******/
            setE2c1(`${costs[16]['cout']}`);
            setE2c2(`${costs[17]['cout']}`);
            setE2e2(`${costs[18]['cout']}`);
            setE2e3(`${costs[19]['cout']}`);
            setE2o2(`${costs[20]['cout']}`);
            setE2o3(`${costs[21]['cout']}`);
            setE2s4(`${costs[22]['cout']}`);
            setE2s5(`${costs[23]['cout']}`);

            /******* Fourth Line *******/
            setE3c1(`${costs[24]['cout']}`);
            setE3c2(`${costs[25]['cout']}`);
            setE3e2(`${costs[26]['cout']}`);
            setE3e3(`${costs[27]['cout']}`);
            setE3o2(`${costs[28]['cout']}`);
            setE3o3(`${costs[29]['cout']}`);
            setE3s4(`${costs[30]['cout']}`);
            setE3s5(`${costs[31]['cout']}`);

            /******* Fifth Line *******/
            setO2c1(`${costs[32]['cout']}`);
            setO2c2(`${costs[33]['cout']}`);
            setO2e2(`${costs[34]['cout']}`);
            setO2e3(`${costs[35]['cout']}`);
            setO2o2(`${costs[36]['cout']}`);
            setO2o3(`${costs[37]['cout']}`);
            setO2s4(`${costs[38]['cout']}`);
            setO2s5(`${costs[39]['cout']}`);

            /******* Sixth Line *******/
            setO3c1(`${costs[40]['cout']}`);
            setO3c2(`${costs[41]['cout']}`);
            setO3e2(`${costs[42]['cout']}`);
            setO3e3(`${costs[43]['cout']}`);
            setO3o2(`${costs[44]['cout']}`);
            setO3o3(`${costs[45]['cout']}`);
            setO3s4(`${costs[46]['cout']}`);
            setO3s5(`${costs[47]['cout']}`);

            /******* Seventh Line *******/
            setS4c1(`${costs[48]['cout']}`);
            setS4c2(`${costs[49]['cout']}`);
            setS4e2(`${costs[50]['cout']}`);
            setS4e3(`${costs[51]['cout']}`);
            setS4o2(`${costs[52]['cout']}`);
            setS4o3(`${costs[53]['cout']}`);
            setS4s4(`${costs[54]['cout']}`);
            setS4s5(`${costs[55]['cout']}`);

            /******* Eighth Line *******/
            setS5c1(`${costs[56]['cout']}`);
            setS5c2(`${costs[57]['cout']}`);
            setS5e2(`${costs[58]['cout']}`);
            setS5e3(`${costs[59]['cout']}`);
            setS5o2(`${costs[60]['cout']}`);
            setS5o3(`${costs[61]['cout']}`);
            setS5s4(`${costs[62]['cout']}`);
            setS5s5(`${costs[63]['cout']}`);

            /******* Ramassage Line *******/
            setRam1(`${costs[64]['cout']}`);
            setRam2(`${costs[65]['cout']}`);
            setRam3(`${costs[66]['cout']}`);
            setRam4(`${costs[67]['cout']}`);
            setRam5(`${costs[68]['cout']}`);

            /******* Ramassage Line *******/
            setDepot1(`${costs[69]['cout']}`);
            setDepot2(`${costs[70]['cout']}`);
            setDepot3(`${costs[71]['cout']}`);
            setDepot4(`${costs[72]['cout']}`);
            setDepot5(`${costs[73]['cout']}`);
        }

        if (costsentreprise.length !== 0) {
            /******* First Line *******/
            setC1c1En(`${costsentreprise[0]['cout']}`);
            setC1c2En(`${costsentreprise[1]['cout']}`);
            setC1e2En(`${costsentreprise[2]['cout']}`);
            setC1e3En(`${costsentreprise[3]['cout']}`);
            setC1o2En(`${costsentreprise[4]['cout']}`);
            setC1o3En(`${costsentreprise[5]['cout']}`);
            setC1s4En(`${costsentreprise[6]['cout']}`);
            setC1s5En(`${costsentreprise[7]['cout']}`);

            /******* Second Line *******/
            setC2c1En(`${costsentreprise[8]['cout']}`);
            setC2c2En(`${costsentreprise[9]['cout']}`);
            setC2e2En(`${costsentreprise[10]['cout']}`);
            setC2e3En(`${costsentreprise[11]['cout']}`);
            setC2o2En(`${costsentreprise[12]['cout']}`);
            setC2o3En(`${costsentreprise[13]['cout']}`);
            setC2s4En(`${costsentreprise[14]['cout']}`);
            setC2s5En(`${costsentreprise[15]['cout']}`);

            /******* Third Line *******/
            setE2c1En(`${costsentreprise[16]['cout']}`);
            setE2c2En(`${costsentreprise[17]['cout']}`);
            setE2e2En(`${costsentreprise[18]['cout']}`);
            setE2e3En(`${costsentreprise[19]['cout']}`);
            setE2o2En(`${costsentreprise[20]['cout']}`);
            setE2o3En(`${costsentreprise[21]['cout']}`);
            setE2s4En(`${costsentreprise[22]['cout']}`);
            setE2s5En(`${costsentreprise[23]['cout']}`);

            /******* Fourth Line *******/
            setE3c1En(`${costsentreprise[24]['cout']}`);
            setE3c2En(`${costsentreprise[25]['cout']}`);
            setE3e2En(`${costsentreprise[26]['cout']}`);
            setE3e3En(`${costsentreprise[27]['cout']}`);
            setE3o2En(`${costsentreprise[28]['cout']}`);
            setE3o3En(`${costsentreprise[29]['cout']}`);
            setE3s4En(`${costsentreprise[30]['cout']}`);
            setE3s5En(`${costsentreprise[31]['cout']}`);

            /******* Fifth Line *******/
            setO2c1En(`${costsentreprise[32]['cout']}`);
            setO2c2En(`${costsentreprise[33]['cout']}`);
            setO2e2En(`${costsentreprise[34]['cout']}`);
            setO2e3En(`${costsentreprise[35]['cout']}`);
            setO2o2En(`${costsentreprise[36]['cout']}`);
            setO2o3En(`${costsentreprise[37]['cout']}`);
            setO2s4En(`${costsentreprise[38]['cout']}`);
            setO2s5En(`${costsentreprise[39]['cout']}`);

            /******* Sixth Line *******/
            setO3c1En(`${costsentreprise[40]['cout']}`);
            setO3c2En(`${costsentreprise[41]['cout']}`);
            setO3e2En(`${costsentreprise[42]['cout']}`);
            setO3e3En(`${costsentreprise[43]['cout']}`);
            setO3o2En(`${costsentreprise[44]['cout']}`);
            setO3o3En(`${costsentreprise[45]['cout']}`);
            setO3s4En(`${costsentreprise[46]['cout']}`);
            setO3s5En(`${costsentreprise[47]['cout']}`);

            /******* Seventh Line *******/
            setS4c1En(`${costsentreprise[48]['cout']}`);
            setS4c2En(`${costsentreprise[49]['cout']}`);
            setS4e2En(`${costsentreprise[50]['cout']}`);
            setS4e3En(`${costsentreprise[51]['cout']}`);
            setS4o2En(`${costsentreprise[52]['cout']}`);
            setS4o3En(`${costsentreprise[53]['cout']}`);
            setS4s4En(`${costsentreprise[54]['cout']}`);
            setS4s5En(`${costsentreprise[55]['cout']}`);

            /******* Eighth Line *******/
            setS5c1En(`${costsentreprise[56]['cout']}`);
            setS5c2En(`${costsentreprise[57]['cout']}`);
            setS5e2En(`${costsentreprise[58]['cout']}`);
            setS5e3En(`${costsentreprise[59]['cout']}`);
            setS5o2En(`${costsentreprise[60]['cout']}`);
            setS5o3En(`${costsentreprise[61]['cout']}`);
            setS5s4En(`${costsentreprise[62]['cout']}`);
            setS5s5En(`${costsentreprise[63]['cout']}`);

            /******* Ramassage Line *******/
            setRam1En(`${costsentreprise[64]['cout']}`);
            setRam2En(`${costsentreprise[65]['cout']}`);
            setRam3En(`${costsentreprise[66]['cout']}`);
            setRam4En(`${costsentreprise[67]['cout']}`);
            setRam5En(`${costsentreprise[68]['cout']}`);

            /******* Ramassage Line *******/
            setDepot1En(`${costsentreprise[69]['cout']}`);
            setDepot2En(`${costsentreprise[70]['cout']}`);
            setDepot3En(`${costsentreprise[71]['cout']}`);
            setDepot4En(`${costsentreprise[72]['cout']}`);
            setDepot5En(`${costsentreprise[73]['cout']}`);
        }
    }, [costs, costsentreprise])

    useEffect(() => {
        setResult(`${cost} DA`);
    }, [cost])

    // useEffect(() => {
    // if (errorUpdate != false) {
    //     setErrorBox(errorUpdate);
    // }
    // }, [errorUpdate])

    useEffect(() => {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' })
    }, [errorBox])

    useEffect(() => {
        if (wilayaSender.id === 0 || wilayaReceiver.id === 0 || weight.trim() == "" || isNaN(weight) || (typeClient.id === 1 && entreprise.id === 0)) {
            setResult("");
        } else {
            simulateGetCost(dispatch, wilayaSender.id, wilayaReceiver.id, weight, typeEnvoie.id, typeDelivery.id, typeRamassage.id, typeClient.id, entreprise.id);
        }
    }, [wilayaSender, wilayaReceiver, weight, typeEnvoie, typeDelivery, typeRamassage, typeClient, entreprise])

    const updateCostsHandler = (e) => {
        e.preventDefault();

        /******* First Line *******/
        if (c1c1.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Centre 1`);
            return;
        }
        if (isNaN(c1c1)) {
            setErrorBox(`Centre 1 Centre 1 doit etre un nombre`);
            return;
        }
        if (c1c2.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Centre 2`);
            return;
        }
        if (isNaN(c1c2)) {
            setErrorBox(`Centre 1 Centre 2 doit etre un nombre`);
            return;
        }
        if (c1e2.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Est 2`);
            return;
        }
        if (isNaN(c1e2)) {
            setErrorBox(`Centre 1 Est 2 doit etre un nombre`);
            return;
        }
        if (c1e3.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Est 3`);
            return;
        }
        if (isNaN(c1e3)) {
            setErrorBox(`Centre 1 Est 3 doit etre un nombre`);
            return;
        }
        if (c1o2.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Ouest 2`);
            return;
        }
        if (isNaN(c1o2)) {
            setErrorBox(`Centre 1 Ouest 2 doit etre un nombre`);
            return;
        }
        if (c1o3.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Ouest 3`);
            return;
        }
        if (isNaN(c1o3)) {
            setErrorBox(`Centre 1 Ouest 3 doit etre un nombre`);
            return;
        }
        if (c1s4.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Sud 4`);
            return;
        }
        if (isNaN(c1s4)) {
            setErrorBox(`Centre 1 Sud 4 doit etre un nombre`);
            return;
        }
        if (c1s5.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Sud 5`);
            return;
        }
        if (isNaN(c1s5)) {
            setErrorBox(`Centre 1 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Second Line *******/
        if (c2c1.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Centre 1`);
            return;
        }
        if (isNaN(c2c1)) {
            setErrorBox(`Centre 2 Centre 1 doit etre un nombre`);
            return;
        }
        if (c2c2.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Centre 2`);
            return;
        }
        if (isNaN(c2c2)) {
            setErrorBox(`Centre 2 Centre 2 doit etre un nombre`);
            return;
        }
        if (c2e2.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Est 2`);
            return;
        }
        if (isNaN(c2e2)) {
            setErrorBox(`Centre 2 Est 2 doit etre un nombre`);
            return;
        }
        if (c2e3.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Est 3`);
            return;
        }
        if (isNaN(c2e3)) {
            setErrorBox(`Centre 2 Est 3 doit etre un nombre`);
            return;
        }
        if (c2o2.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Ouest 2`);
            return;
        }
        if (isNaN(c2o2)) {
            setErrorBox(`Centre 2 Ouest 2 doit etre un nombre`);
            return;
        }
        if (c2o3.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Ouest 3`);
            return;
        }
        if (isNaN(c2o3)) {
            setErrorBox(`Centre 2 Ouest 3 doit etre un nombre`);
            return;
        }
        if (c2s4.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Sud 4`);
            return;
        }
        if (isNaN(c2s4)) {
            setErrorBox(`Centre 2 Sud 4 doit etre un nombre`);
            return;
        }
        if (c2s5.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Sud 5`);
            return;
        }
        if (isNaN(c2s5)) {
            setErrorBox(`Centre 2 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Third Line *******/
        if (e2c1.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Centre 1`);
            return;
        }
        if (isNaN(e2c1)) {
            setErrorBox(`Est 2 Centre 1 doit etre un nombre`);
            return;
        }
        if (e2c2.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Centre 2`);
            return;
        }
        if (isNaN(e2c2)) {
            setErrorBox(`Est 2 Centre 2 doit etre un nombre`);
            return;
        }
        if (e2e2.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Est 2`);
            return;
        }
        if (isNaN(e2e2)) {
            setErrorBox(`Est 2 Est 2 doit etre un nombre`);
            return;
        }
        if (e2e3.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Est 3`);
            return;
        }
        if (isNaN(e2e3)) {
            setErrorBox(`Est 2 Est 3 doit etre un nombre`);
            return;
        }
        if (e2o2.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Ouest 2`);
            return;
        }
        if (isNaN(e2o2)) {
            setErrorBox(`Est 2 Ouest 2 doit etre un nombre`);
            return;
        }
        if (e2o3.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Ouest 3`);
            return;
        }
        if (isNaN(e2o3)) {
            setErrorBox(`Est 2 Ouest 3 doit etre un nombre`);
            return;
        }
        if (e2s4.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Sud 4`);
            return;
        }
        if (isNaN(e2s4)) {
            setErrorBox(`Est 2 Sud 4 doit etre un nombre`);
            return;
        }
        if (e2s5.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Sud 5`);
            return;
        }
        if (isNaN(e2s5)) {
            setErrorBox(`Est 2 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Fourth Line *******/
        if (e3c1.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Centre 1`);
            return;
        }
        if (isNaN(e3c1)) {
            setErrorBox(`Est 3 Centre 1 doit etre un nombre`);
            return;
        }
        if (e3c2.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Centre 2`);
            return;
        }
        if (isNaN(e3c2)) {
            setErrorBox(`Est 3 Centre 2 doit etre un nombre`);
            return;
        }
        if (e3e2.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Est 2`);
            return;
        }
        if (isNaN(e3e2)) {
            setErrorBox(`Est 3 Est 2 doit etre un nombre`);
            return;
        }
        if (e3e3.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Est 3`);
            return;
        }
        if (isNaN(e3e3)) {
            setErrorBox(`Est 3 Est 3 doit etre un nombre`);
            return;
        }
        if (e3o2.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Ouest 2`);
            return;
        }
        if (isNaN(e3o2)) {
            setErrorBox(`Est 3 Ouest 2 doit etre un nombre`);
            return;
        }
        if (e3o3.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Ouest 3`);
            return;
        }
        if (isNaN(e3o3)) {
            setErrorBox(`Est 3 Ouest 3 doit etre un nombre`);
            return;
        }
        if (e3s4.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Sud 4`);
            return;
        }
        if (isNaN(e3s4)) {
            setErrorBox(`Est 3 Sud 4 doit etre un nombre`);
            return;
        }
        if (e3s5.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Sud 5`);
            return;
        }
        if (isNaN(e3s5)) {
            setErrorBox(`Est 3 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Fifth Line *******/
        if (o2c1.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Centre 1`);
            return;
        }
        if (isNaN(o2c1)) {
            setErrorBox(`Ouest 2 Centre 1 doit etre un nombre`);
            return;
        }
        if (o2c2.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Centre 2`);
            return;
        }
        if (isNaN(o2c2)) {
            setErrorBox(`Ouest 2 Centre 2 doit etre un nombre`);
            return;
        }
        if (o2e2.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Est 2`);
            return;
        }
        if (isNaN(o2e2)) {
            setErrorBox(`Ouest 2 Est 2 doit etre un nombre`);
            return;
        }
        if (o2e3.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Est 3`);
            return;
        }
        if (isNaN(o2e3)) {
            setErrorBox(`Ouest 2 Est 3 doit etre un nombre`);
            return;
        }
        if (o2o2.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Ouest 2`);
            return;
        }
        if (isNaN(o2o2)) {
            setErrorBox(`Ouest 2 Ouest 2 doit etre un nombre`);
            return;
        }
        if (o2o3.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Ouest 3`);
            return;
        }
        if (isNaN(o2o3)) {
            setErrorBox(`Ouest 2 Ouest 3 doit etre un nombre`);
            return;
        }
        if (o2s4.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Sud 4`);
            return;
        }
        if (isNaN(o2s4)) {
            setErrorBox(`Ouest 2 Sud 4 doit etre un nombre`);
            return;
        }
        if (o2s5.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Sud 5`);
            return;
        }
        if (isNaN(o2s5)) {
            setErrorBox(`Ouest 2 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Sixth Line *******/
        if (o3c1.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Centre 1`);
            return;
        }
        if (isNaN(o3c1)) {
            setErrorBox(`Ouest 3 Centre 1 doit etre un nombre`);
            return;
        }
        if (o3c2.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Centre 2`);
            return;
        }
        if (isNaN(o3c2)) {
            setErrorBox(`Ouest 3 Centre 2 doit etre un nombre`);
            return;
        }
        if (o3e2.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Est 2`);
            return;
        }
        if (isNaN(o3e2)) {
            setErrorBox(`Ouest 3 Est 2 doit etre un nombre`);
            return;
        }
        if (o3e3.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Est 3`);
            return;
        }
        if (isNaN(o3e3)) {
            setErrorBox(`Ouest 3 Est 3 doit etre un nombre`);
            return;
        }
        if (o3o2.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Ouest 2`);
            return;
        }
        if (isNaN(o3o2)) {
            setErrorBox(`Ouest 3 Ouest 2 doit etre un nombre`);
            return;
        }
        if (o3o3.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Ouest 3`);
            return;
        }
        if (isNaN(o3o3)) {
            setErrorBox(`Ouest 3 Ouest 3 doit etre un nombre`);
            return;
        }
        if (o3s4.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Sud 4`);
            return;
        }
        if (isNaN(o3s4)) {
            setErrorBox(`Ouest 3 Sud 4 doit etre un nombre`);
            return;
        }
        if (o3s5.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Sud 5`);
            return;
        }
        if (isNaN(o3s5)) {
            setErrorBox(`Ouest 3 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Seventh Line *******/
        if (s4c1.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Centre 1`);
            return;
        }
        if (isNaN(s4c1)) {
            setErrorBox(`Sud 4 Centre 1 doit etre un nombre`);
            return;
        }
        if (s4c2.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Centre 2`);
            return;
        }
        if (isNaN(s4c2)) {
            setErrorBox(`Sud 4 Centre 2 doit etre un nombre`);
            return;
        }
        if (s4e2.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Est 2`);
            return;
        }
        if (isNaN(s4e2)) {
            setErrorBox(`Sud 4 Est 2 doit etre un nombre`);
            return;
        }
        if (s4e3.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Est 3`);
            return;
        }
        if (isNaN(s4e3)) {
            setErrorBox(`Sud 4 Est 3 doit etre un nombre`);
            return;
        }
        if (s4o2.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Ouest 2`);
            return;
        }
        if (isNaN(s4o2)) {
            setErrorBox(`Sud 4 Ouest 2 doit etre un nombre`);
            return;
        }
        if (s4o3.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Ouest 3`);
            return;
        }
        if (isNaN(s4o3)) {
            setErrorBox(`Sud 4 Ouest 3 doit etre un nombre`);
            return;
        }
        if (s4s4.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Sud 4`);
            return;
        }
        if (isNaN(s4s4)) {
            setErrorBox(`Sud 4 Sud 4 doit etre un nombre`);
            return;
        }
        if (s4s5.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Sud 5`);
            return;
        }
        if (isNaN(s4s5)) {
            setErrorBox(`Sud 4 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Eighth Line *******/
        if (s5c1.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Centre 1`);
            return;
        }
        if (isNaN(s5c1)) {
            setErrorBox(`Sud 5 Centre 1 doit etre un nombre`);
            return;
        }
        if (s5c2.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Centre 2`);
            return;
        }
        if (isNaN(s5c2)) {
            setErrorBox(`Sud 5 Centre 2 doit etre un nombre`);
            return;
        }
        if (s5e2.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Est 2`);
            return;
        }
        if (isNaN(s5e2)) {
            setErrorBox(`Sud 5 Est 2 doit etre un nombre`);
            return;
        }
        if (s5e3.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Est 3`);
            return;
        }
        if (isNaN(s5e3)) {
            setErrorBox(`Sud 5 Est 3 doit etre un nombre`);
            return;
        }
        if (s5o2.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Ouest 2`);
            return;
        }
        if (isNaN(s5o2)) {
            setErrorBox(`Sud 5 Ouest 2 doit etre un nombre`);
            return;
        }
        if (s5o3.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Ouest 3`);
            return;
        }
        if (isNaN(s5o3)) {
            setErrorBox(`Sud 5 Ouest 3 doit etre un nombre`);
            return;
        }
        if (s5s4.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Sud 4`);
            return;
        }
        if (isNaN(s5s4)) {
            setErrorBox(`Sud 5 Sud 4 doit etre un nombre`);
            return;
        }
        if (s5s5.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Sud 5`);
            return;
        }
        if (isNaN(s5s5)) {
            setErrorBox(`Sud 5 Sud 5 doit etre un nombre`);
            return;
        }

        /******* Ramassage Line *******/
        if (ram1.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 1`);
            return;
        }
        if (isNaN(ram1)) {
            setErrorBox(`Ramassage dans la Zone 1 doit etre un nombre`);
            return;
        }
        if (ram2.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 2`);
            return;
        }
        if (isNaN(ram2)) {
            setErrorBox(`Ramassage dans la Zone 2 doit etre un nombre`);
            return;
        }
        if (ram3.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 3`);
            return;
        }
        if (isNaN(ram3)) {
            setErrorBox(`Ramassage dans la Zone 3 doit etre un nombre`);
            return;
        }
        if (ram4.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 4`);
            return;
        }
        if (isNaN(ram4)) {
            setErrorBox(`Ramassage dans la Zone 4 doit etre un nombre`);
            return;
        }
        if (ram5.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 5`);
            return;
        }
        if (isNaN(ram5)) {
            setErrorBox(`Ramassage dans la Zone 5 doit etre un nombre`);
            return;
        }

        /******* Depot Line *******/
        if (depot1.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 1`);
            return;
        }
        if (isNaN(depot1)) {
            setErrorBox(`Depot dans la Zone 1 doit etre un nombre`);
            return;
        }
        if (depot2.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 2`);
            return;
        }
        if (isNaN(depot2)) {
            setErrorBox(`Depot dans la Zone 2 doit etre un nombre`);
            return;
        }
        if (depot3.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 3`);
            return;
        }
        if (isNaN(depot3)) {
            setErrorBox(`Depot dans la Zone 3 doit etre un nombre`);
            return;
        }
        if (depot4.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 4`);
            return;
        }
        if (isNaN(depot4)) {
            setErrorBox(`Depot dans la Zone 4 doit etre un nombre`);
            return;
        }
        if (depot5.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 5`);
            return;
        }
        if (isNaN(depot5)) {
            setErrorBox(`Depot dans la Zone 5 doit etre un nombre`);
            return;
        }

        updateCosts(dispatch, { c1c1, c1c2, c1e2, c1e3, c1o2, c1o3, c1s4, c1s5, c2c1, c2c2, c2e2, c2e3, c2o2, c2o3, c2s4, c2s5, e2c1, e2c2, e2e2, e2e3, e2o2, e2o3, e2s4, e2s5, e3c1, e3c2, e3e2, e3e3, e3o2, e3o3, e3s4, e3s5, o2c1, o2c2, o2e2, o2e3, o2o2, o2o3, o2s4, o2s5, o3c1, o3c2, o3e2, o3e3, o3o2, o3o3, o3s4, o3s5, s4c1, s4c2, s4e2, s4e3, s4o2, s4o3, s4s4, s4s5, s5c1, s5c2, s5e2, s5e3, s5o2, s5o3, s5s4, s5s5, ram1, ram2, ram3, ram4, ram5, depot1, depot2, depot3, depot4, depot5 });

    }

    const updateCostsEntrepriseHandler = (e) => {
        e.preventDefault();

        /******* First Line *******/
        if (c1c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Centre 1`);
            return;
        }
        if (isNaN(c1c1en)) {
            setErrorBox(`Centre 1 Centre 1 doit etre un nombre`);
            return;
        }
        if (c1c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Centre 2`);
            return;
        }
        if (isNaN(c1c2en)) {
            setErrorBox(`Centre 1 Centre 2 doit etre un nombre`);
            return;
        }
        if (c1e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Est 2`);
            return;
        }
        if (isNaN(c1e2en)) {
            setErrorBox(`Centre 1 Est 2 doit etre un nombre`);
            return;
        }
        if (c1e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Est 3`);
            return;
        }
        if (isNaN(c1e3en)) {
            setErrorBox(`Centre 1 Est 3 doit etre un nombre`);
            return;
        }
        if (c1o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Ouest 2`);
            return;
        }
        if (isNaN(c1o2en)) {
            setErrorBox(`Centre 1 Ouest 2 doit etre un nombre`);
            return;
        }
        if (c1o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Ouest 3`);
            return;
        }
        if (isNaN(c1o3en)) {
            setErrorBox(`Centre 1 Ouest 3 doit etre un nombre`);
            return;
        }
        if (c1s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Sud 4`);
            return;
        }
        if (isNaN(c1s4en)) {
            setErrorBox(`Centre 1 Sud 4 doit etre un nombre`);
            return;
        }
        if (c1s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 1 Sud 5`);
            return;
        }
        if (isNaN(c1s5en)) {
            setErrorBox(`Centre 1 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Second Line *******/
        if (c2c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Centre 1`);
            return;
        }
        if (isNaN(c2c1en)) {
            setErrorBox(`Centre 2 Centre 1 doit etre un nombre`);
            return;
        }
        if (c2c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Centre 2`);
            return;
        }
        if (isNaN(c2c2en)) {
            setErrorBox(`Centre 2 Centre 2 doit etre un nombre`);
            return;
        }
        if (c2e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Est 2`);
            return;
        }
        if (isNaN(c2e2en)) {
            setErrorBox(`Centre 2 Est 2 doit etre un nombre`);
            return;
        }
        if (c2e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Est 3`);
            return;
        }
        if (isNaN(c2e3en)) {
            setErrorBox(`Centre 2 Est 3 doit etre un nombre`);
            return;
        }
        if (c2o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Ouest 2`);
            return;
        }
        if (isNaN(c2o2en)) {
            setErrorBox(`Centre 2 Ouest 2 doit etre un nombre`);
            return;
        }
        if (c2o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Ouest 3`);
            return;
        }
        if (isNaN(c2o3en)) {
            setErrorBox(`Centre 2 Ouest 3 doit etre un nombre`);
            return;
        }
        if (c2s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Sud 4`);
            return;
        }
        if (isNaN(c2s4en)) {
            setErrorBox(`Centre 2 Sud 4 doit etre un nombre`);
            return;
        }
        if (c2s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Centre 2 Sud 5`);
            return;
        }
        if (isNaN(c2s5en)) {
            setErrorBox(`Centre 2 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Third Line *******/
        if (e2c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Centre 1`);
            return;
        }
        if (isNaN(e2c1en)) {
            setErrorBox(`Est 2 Centre 1 doit etre un nombre`);
            return;
        }
        if (e2c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Centre 2`);
            return;
        }
        if (isNaN(e2c2en)) {
            setErrorBox(`Est 2 Centre 2 doit etre un nombre`);
            return;
        }
        if (e2e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Est 2`);
            return;
        }
        if (isNaN(e2e2en)) {
            setErrorBox(`Est 2 Est 2 doit etre un nombre`);
            return;
        }
        if (e2e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Est 3`);
            return;
        }
        if (isNaN(e2e3en)) {
            setErrorBox(`Est 2 Est 3 doit etre un nombre`);
            return;
        }
        if (e2o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Ouest 2`);
            return;
        }
        if (isNaN(e2o2en)) {
            setErrorBox(`Est 2 Ouest 2 doit etre un nombre`);
            return;
        }
        if (e2o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Ouest 3`);
            return;
        }
        if (isNaN(e2o3en)) {
            setErrorBox(`Est 2 Ouest 3 doit etre un nombre`);
            return;
        }
        if (e2s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Sud 4`);
            return;
        }
        if (isNaN(e2s4en)) {
            setErrorBox(`Est 2 Sud 4 doit etre un nombre`);
            return;
        }
        if (e2s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 2 Sud 5`);
            return;
        }
        if (isNaN(e2s5en)) {
            setErrorBox(`Est 2 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Fourth Line *******/
        if (e3c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Centre 1`);
            return;
        }
        if (isNaN(e3c1en)) {
            setErrorBox(`Est 3 Centre 1 doit etre un nombre`);
            return;
        }
        if (e3c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Centre 2`);
            return;
        }
        if (isNaN(e3c2en)) {
            setErrorBox(`Est 3 Centre 2 doit etre un nombre`);
            return;
        }
        if (e3e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Est 2`);
            return;
        }
        if (isNaN(e3e2en)) {
            setErrorBox(`Est 3 Est 2 doit etre un nombre`);
            return;
        }
        if (e3e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Est 3`);
            return;
        }
        if (isNaN(e3e3en)) {
            setErrorBox(`Est 3 Est 3 doit etre un nombre`);
            return;
        }
        if (e3o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Ouest 2`);
            return;
        }
        if (isNaN(e3o2en)) {
            setErrorBox(`Est 3 Ouest 2 doit etre un nombre`);
            return;
        }
        if (e3o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Ouest 3`);
            return;
        }
        if (isNaN(e3o3en)) {
            setErrorBox(`Est 3 Ouest 3 doit etre un nombre`);
            return;
        }
        if (e3s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Sud 4`);
            return;
        }
        if (isNaN(e3s4en)) {
            setErrorBox(`Est 3 Sud 4 doit etre un nombre`);
            return;
        }
        if (e3s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Est 3 Sud 5`);
            return;
        }
        if (isNaN(e3s5en)) {
            setErrorBox(`Est 3 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Fifth Line *******/
        if (o2c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Centre 1`);
            return;
        }
        if (isNaN(o2c1en)) {
            setErrorBox(`Ouest 2 Centre 1 doit etre un nombre`);
            return;
        }
        if (o2c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Centre 2`);
            return;
        }
        if (isNaN(o2c2en)) {
            setErrorBox(`Ouest 2 Centre 2 doit etre un nombre`);
            return;
        }
        if (o2e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Est 2`);
            return;
        }
        if (isNaN(o2e2en)) {
            setErrorBox(`Ouest 2 Est 2 doit etre un nombre`);
            return;
        }
        if (o2e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Est 3`);
            return;
        }
        if (isNaN(o2e3en)) {
            setErrorBox(`Ouest 2 Est 3 doit etre un nombre`);
            return;
        }
        if (o2o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Ouest 2`);
            return;
        }
        if (isNaN(o2o2en)) {
            setErrorBox(`Ouest 2 Ouest 2 doit etre un nombre`);
            return;
        }
        if (o2o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Ouest 3`);
            return;
        }
        if (isNaN(o2o3en)) {
            setErrorBox(`Ouest 2 Ouest 3 doit etre un nombre`);
            return;
        }
        if (o2s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Sud 4`);
            return;
        }
        if (isNaN(o2s4en)) {
            setErrorBox(`Ouest 2 Sud 4 doit etre un nombre`);
            return;
        }
        if (o2s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 2 Sud 5`);
            return;
        }
        if (isNaN(o2s5en)) {
            setErrorBox(`Ouest 2 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Sixth Line *******/
        if (o3c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Centre 1`);
            return;
        }
        if (isNaN(o3c1en)) {
            setErrorBox(`Ouest 3 Centre 1 doit etre un nombre`);
            return;
        }
        if (o3c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Centre 2`);
            return;
        }
        if (isNaN(o3c2en)) {
            setErrorBox(`Ouest 3 Centre 2 doit etre un nombre`);
            return;
        }
        if (o3e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Est 2`);
            return;
        }
        if (isNaN(o3e2en)) {
            setErrorBox(`Ouest 3 Est 2 doit etre un nombre`);
            return;
        }
        if (o3e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Est 3`);
            return;
        }
        if (isNaN(o3e3en)) {
            setErrorBox(`Ouest 3 Est 3 doit etre un nombre`);
            return;
        }
        if (o3o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Ouest 2`);
            return;
        }
        if (isNaN(o3o2en)) {
            setErrorBox(`Ouest 3 Ouest 2 doit etre un nombre`);
            return;
        }
        if (o3o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Ouest 3`);
            return;
        }
        if (isNaN(o3o3en)) {
            setErrorBox(`Ouest 3 Ouest 3 doit etre un nombre`);
            return;
        }
        if (o3s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Sud 4`);
            return;
        }
        if (isNaN(o3s4en)) {
            setErrorBox(`Ouest 3 Sud 4 doit etre un nombre`);
            return;
        }
        if (o3s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Ouest 3 Sud 5`);
            return;
        }
        if (isNaN(o3s5en)) {
            setErrorBox(`Ouest 3 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Seventh Line *******/
        if (s4c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Centre 1`);
            return;
        }
        if (isNaN(s4c1en)) {
            setErrorBox(`Sud 4 Centre 1 doit etre un nombre`);
            return;
        }
        if (s4c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Centre 2`);
            return;
        }
        if (isNaN(s4c2en)) {
            setErrorBox(`Sud 4 Centre 2 doit etre un nombre`);
            return;
        }
        if (s4e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Est 2`);
            return;
        }
        if (isNaN(s4e2en)) {
            setErrorBox(`Sud 4 Est 2 doit etre un nombre`);
            return;
        }
        if (s4e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Est 3`);
            return;
        }
        if (isNaN(s4e3en)) {
            setErrorBox(`Sud 4 Est 3 doit etre un nombre`);
            return;
        }
        if (s4o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Ouest 2`);
            return;
        }
        if (isNaN(s4o2en)) {
            setErrorBox(`Sud 4 Ouest 2 doit etre un nombre`);
            return;
        }
        if (s4o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Ouest 3`);
            return;
        }
        if (isNaN(s4o3en)) {
            setErrorBox(`Sud 4 Ouest 3 doit etre un nombre`);
            return;
        }
        if (s4s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Sud 4`);
            return;
        }
        if (isNaN(s4s4en)) {
            setErrorBox(`Sud 4 Sud 4 doit etre un nombre`);
            return;
        }
        if (s4s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 4 Sud 5`);
            return;
        }
        if (isNaN(s4s5en)) {
            setErrorBox(`Sud 4 Sud 5 doit etre un nombre`);
            return;
        }
        /******* Eighth Line *******/
        if (s5c1en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Centre 1`);
            return;
        }
        if (isNaN(s5c1en)) {
            setErrorBox(`Sud 5 Centre 1 doit etre un nombre`);
            return;
        }
        if (s5c2en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Centre 2`);
            return;
        }
        if (isNaN(s5c2en)) {
            setErrorBox(`Sud 5 Centre 2 doit etre un nombre`);
            return;
        }
        if (s5e2en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Est 2`);
            return;
        }
        if (isNaN(s5e2en)) {
            setErrorBox(`Sud 5 Est 2 doit etre un nombre`);
            return;
        }
        if (s5e3en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Est 3`);
            return;
        }
        if (isNaN(s5e3en)) {
            setErrorBox(`Sud 5 Est 3 doit etre un nombre`);
            return;
        }
        if (s5o2en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Ouest 2`);
            return;
        }
        if (isNaN(s5o2en)) {
            setErrorBox(`Sud 5 Ouest 2 doit etre un nombre`);
            return;
        }
        if (s5o3en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Ouest 3`);
            return;
        }
        if (isNaN(s5o3en)) {
            setErrorBox(`Sud 5 Ouest 3 doit etre un nombre`);
            return;
        }
        if (s5s4en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Sud 4`);
            return;
        }
        if (isNaN(s5s4en)) {
            setErrorBox(`Sud 5 Sud 4 doit etre un nombre`);
            return;
        }
        if (s5s5en.trim() == "") {
            setErrorBox(`Vous devez compléter Sud 5 Sud 5`);
            return;
        }
        if (isNaN(s5s5en)) {
            setErrorBox(`Sud 5 Sud 5 doit etre un nombre`);
            return;
        }

        /******* Ramassage Line *******/
        if (ram1en.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 1`);
            return;
        }
        if (isNaN(ram1en)) {
            setErrorBox(`Ramassage dans la Zone 1 doit etre un nombre`);
            return;
        }
        if (ram2en.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 2`);
            return;
        }
        if (isNaN(ram2en)) {
            setErrorBox(`Ramassage dans la Zone 2 doit etre un nombre`);
            return;
        }
        if (ram3en.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 3`);
            return;
        }
        if (isNaN(ram3en)) {
            setErrorBox(`Ramassage dans la Zone 3 doit etre un nombre`);
            return;
        }
        if (ram4en.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 4`);
            return;
        }
        if (isNaN(ram4en)) {
            setErrorBox(`Ramassage dans la Zone 4 doit etre un nombre`);
            return;
        }
        if (ram5en.trim() == "") {
            setErrorBox(`Vous devez compléter Ramassage dans la Zone 5`);
            return;
        }
        if (isNaN(ram5en)) {
            setErrorBox(`Ramassage dans la Zone 5 doit etre un nombre`);
            return;
        }

        /******* Depot Line *******/
        if (depot1en.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 1`);
            return;
        }
        if (isNaN(depot1en)) {
            setErrorBox(`Depot dans la Zone 1 doit etre un nombre`);
            return;
        }
        if (depot2en.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 2`);
            return;
        }
        if (isNaN(depot2en)) {
            setErrorBox(`Depot dans la Zone 2 doit etre un nombre`);
            return;
        }
        if (depot3en.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 3`);
            return;
        }
        if (isNaN(depot3en)) {
            setErrorBox(`Depot dans la Zone 3 doit etre un nombre`);
            return;
        }
        if (depot4en.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 4`);
            return;
        }
        if (isNaN(depot4en)) {
            setErrorBox(`Depot dans la Zone 4 doit etre un nombre`);
            return;
        }
        if (depot5en.trim() == "") {
            setErrorBox(`Vous devez compléter Depot dans la Zone 5`);
            return;
        }
        if (isNaN(depot5en)) {
            setErrorBox(`Depot dans la Zone 5 doit etre un nombre`);
            return;
        }

        updateCostsEntreprise(dispatch, { c1c1en, c1c2en, c1e2en, c1e3en, c1o2en, c1o3en, c1s4en, c1s5en, c2c1en, c2c2en, c2e2en, c2e3en, c2o2en, c2o3en, c2s4en, c2s5en, e2c1en, e2c2en, e2e2en, e2e3en, e2o2en, e2o3en, e2s4en, e2s5en, e3c1en, e3c2en, e3e2en, e3e3en, e3o2en, e3o3en, e3s4en, e3s5en, o2c1en, o2c2en, o2e2en, o2e3en, o2o2en, o2o3en, o2s4en, o2s5en, o3c1en, o3c2en, o3e2en, o3e3en, o3o2en, o3o3en, o3s4en, o3s5en, s4c1en, s4c2en, s4e2en, s4e3en, s4o2en, s4o3en, s4s4en, s4s5en, s5c1en, s5c2en, s5e2en, s5e3en, s5o2en, s5o3en, s5s4en, s5s5en, ram1en, ram2en, ram3en, ram4en, ram5en, depot1en, depot2en, depot3en, depot4en, depot5en });

    }

    /******* First Line *******/
    const [c1c1, setC1c1] = useState("");
    const [c1c2, setC1c2] = useState("");
    const [c1e2, setC1e2] = useState("");
    const [c1e3, setC1e3] = useState("");
    const [c1o2, setC1o2] = useState("");
    const [c1o3, setC1o3] = useState("");
    const [c1s4, setC1s4] = useState("");
    const [c1s5, setC1s5] = useState("");

    /******* Second Line *******/
    const [c2c1, setC2c1] = useState("");
    const [c2c2, setC2c2] = useState("");
    const [c2e2, setC2e2] = useState("");
    const [c2e3, setC2e3] = useState("");
    const [c2o2, setC2o2] = useState("");
    const [c2o3, setC2o3] = useState("");
    const [c2s4, setC2s4] = useState("");
    const [c2s5, setC2s5] = useState("");

    /******* Third Line *******/
    const [e2c1, setE2c1] = useState("");
    const [e2c2, setE2c2] = useState("");
    const [e2e2, setE2e2] = useState("");
    const [e2e3, setE2e3] = useState("");
    const [e2o2, setE2o2] = useState("");
    const [e2o3, setE2o3] = useState("");
    const [e2s4, setE2s4] = useState("");
    const [e2s5, setE2s5] = useState("");

    /******* Fourth Line *******/
    const [e3c1, setE3c1] = useState("");
    const [e3c2, setE3c2] = useState("");
    const [e3e2, setE3e2] = useState("");
    const [e3e3, setE3e3] = useState("");
    const [e3o2, setE3o2] = useState("");
    const [e3o3, setE3o3] = useState("");
    const [e3s4, setE3s4] = useState("");
    const [e3s5, setE3s5] = useState("");

    /******* Fifth Line *******/
    const [o2c1, setO2c1] = useState("");
    const [o2c2, setO2c2] = useState("");
    const [o2e2, setO2e2] = useState("");
    const [o2e3, setO2e3] = useState("");
    const [o2o2, setO2o2] = useState("");
    const [o2o3, setO2o3] = useState("");
    const [o2s4, setO2s4] = useState("");
    const [o2s5, setO2s5] = useState("");

    /******* Sixth Line *******/
    const [o3c1, setO3c1] = useState("");
    const [o3c2, setO3c2] = useState("");
    const [o3e2, setO3e2] = useState("");
    const [o3e3, setO3e3] = useState("");
    const [o3o2, setO3o2] = useState("");
    const [o3o3, setO3o3] = useState("");
    const [o3s4, setO3s4] = useState("");
    const [o3s5, setO3s5] = useState("");

    /******* Seventh Line *******/
    const [s4c1, setS4c1] = useState("");
    const [s4c2, setS4c2] = useState("");
    const [s4e2, setS4e2] = useState("");
    const [s4e3, setS4e3] = useState("");
    const [s4o2, setS4o2] = useState("");
    const [s4o3, setS4o3] = useState("");
    const [s4s4, setS4s4] = useState("");
    const [s4s5, setS4s5] = useState("");

    /******* Eighth Line *******/
    const [s5c1, setS5c1] = useState("");
    const [s5c2, setS5c2] = useState("");
    const [s5e2, setS5e2] = useState("");
    const [s5e3, setS5e3] = useState("");
    const [s5o2, setS5o2] = useState("");
    const [s5o3, setS5o3] = useState("");
    const [s5s4, setS5s4] = useState("");
    const [s5s5, setS5s5] = useState("");

    /******* Depot and Ramassage *******/
    const [ram1, setRam1] = useState("");
    const [ram2, setRam2] = useState("");
    const [ram3, setRam3] = useState("");
    const [ram4, setRam4] = useState("");
    const [ram5, setRam5] = useState("");
    const [depot1, setDepot1] = useState("");
    const [depot2, setDepot2] = useState("");
    const [depot3, setDepot3] = useState("");
    const [depot4, setDepot4] = useState("");
    const [depot5, setDepot5] = useState("");

     /******* First Line *******/
     const [c1c1en, setC1c1En] = useState("");
     const [c1c2en, setC1c2En] = useState("");
     const [c1e2en, setC1e2En] = useState("");
     const [c1e3en, setC1e3En] = useState("");
     const [c1o2en, setC1o2En] = useState("");
     const [c1o3en, setC1o3En] = useState("");
     const [c1s4en, setC1s4En] = useState("");
     const [c1s5en, setC1s5En] = useState("");
 
     /******* Second Line *******/
     const [c2c1en, setC2c1En] = useState("");
     const [c2c2en, setC2c2En] = useState("");
     const [c2e2en, setC2e2En] = useState("");
     const [c2e3en, setC2e3En] = useState("");
     const [c2o2en, setC2o2En] = useState("");
     const [c2o3en, setC2o3En] = useState("");
     const [c2s4en, setC2s4En] = useState("");
     const [c2s5en, setC2s5En] = useState("");
 
     /******* Third Line *******/
     const [e2c1en, setE2c1En] = useState("");
     const [e2c2en, setE2c2En] = useState("");
     const [e2e2en, setE2e2En] = useState("");
     const [e2e3en, setE2e3En] = useState("");
     const [e2o2en, setE2o2En] = useState("");
     const [e2o3en, setE2o3En] = useState("");
     const [e2s4en, setE2s4En] = useState("");
     const [e2s5en, setE2s5En] = useState("");
 
     /******* Fourth Line *******/
     const [e3c1en, setE3c1En] = useState("");
     const [e3c2en, setE3c2En] = useState("");
     const [e3e2en, setE3e2En] = useState("");
     const [e3e3en, setE3e3En] = useState("");
     const [e3o2en, setE3o2En] = useState("");
     const [e3o3en, setE3o3En] = useState("");
     const [e3s4en, setE3s4En] = useState("");
     const [e3s5en, setE3s5En] = useState("");
 
     /******* Fifth Line *******/
     const [o2c1en, setO2c1En] = useState("");
     const [o2c2en, setO2c2En] = useState("");
     const [o2e2en, setO2e2En] = useState("");
     const [o2e3en, setO2e3En] = useState("");
     const [o2o2en, setO2o2En] = useState("");
     const [o2o3en, setO2o3En] = useState("");
     const [o2s4en, setO2s4En] = useState("");
     const [o2s5en, setO2s5En] = useState("");
 
     /******* Sixth Line *******/
     const [o3c1en, setO3c1En] = useState("");
     const [o3c2en, setO3c2En] = useState("");
     const [o3e2en, setO3e2En] = useState("");
     const [o3e3en, setO3e3En] = useState("");
     const [o3o2en, setO3o2En] = useState("");
     const [o3o3en, setO3o3En] = useState("");
     const [o3s4en, setO3s4En] = useState("");
     const [o3s5en, setO3s5En] = useState("");
 
     /******* Seventh Line *******/
     const [s4c1en, setS4c1En] = useState("");
     const [s4c2en, setS4c2En] = useState("");
     const [s4e2en, setS4e2En] = useState("");
     const [s4e3en, setS4e3En] = useState("");
     const [s4o2en, setS4o2En] = useState("");
     const [s4o3en, setS4o3En] = useState("");
     const [s4s4en, setS4s4En] = useState("");
     const [s4s5en, setS4s5En] = useState("");
 
     /******* Eighth Line *******/
     const [s5c1en, setS5c1En] = useState("");
     const [s5c2en, setS5c2En] = useState("");
     const [s5e2en, setS5e2En] = useState("");
     const [s5e3en, setS5e3En] = useState("");
     const [s5o2en, setS5o2En] = useState("");
     const [s5o3en, setS5o3En] = useState("");
     const [s5s4en, setS5s4En] = useState("");
     const [s5s5en, setS5s5En] = useState("");
 
     /******* Depot and Ramassage *******/
     const [ram1en, setRam1En] = useState("");
     const [ram2en, setRam2En] = useState("");
     const [ram3en, setRam3En] = useState("");
     const [ram4en, setRam4En] = useState("");
     const [ram5en, setRam5En] = useState("");
     const [depot1en, setDepot1En] = useState("");
     const [depot2en, setDepot2En] = useState("");
     const [depot3en, setDepot3En] = useState("");
     const [depot4en, setDepot4En] = useState("");
     const [depot5en, setDepot5En] = useState("");

    return (
        <div className='container-global'>
            <AdminSideBar activeTab="cost" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Prix :</span>
                </div>

                {errorBox !== "" && (<div style={{ marginBottom: "25px" }} className='box-error'>{errorBox}</div>)}

                {
                    errorCosts ? <ErrorComponent error={errorCosts} /> : (
                        isFetchingCosts ? <LoadingComponent /> : (
                            costs.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                : (
                                    <>
                                        <div className="filter" style={{ maxWidth: "1400px", margin: "0 auto 25px" }}>
                                            <div style={{ margin: "20px 20px 40px" }}>
                                                <FormRadio data={pricesClientsAndEntreprises} itemChoisir={priceClientsAndEntreprises} setItemChoisir={setPriceClientsAndEntreprises} name='tab-client-entreprise' />
                                            </div>

                                            {/* Costs of clients */}
                                            <div className={priceClientsAndEntreprises.id === 1 ? "filter-content deactive" : "filter-content"}>
                                                { /******* First Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Centre 1 Centre 1' itemInput={c1c1} setItemInput={setC1c1} />
                                                    <FormInput label='Centre 1 Centre 2' itemInput={c1c2} setItemInput={setC1c2} />
                                                    <FormInput label='Centre 1 Est 2' itemInput={c1e2} setItemInput={setC1e2} />
                                                    <FormInput label='Centre 1 Est 3' itemInput={c1e3} setItemInput={setC1e3} />
                                                    <FormInput label='Centre 1 Ouest 2' itemInput={c1o2} setItemInput={setC1o2} />
                                                    <FormInput label='Centre 1 Ouest 3' itemInput={c1o3} setItemInput={setC1o3} />
                                                    <FormInput label='Centre 1 Sud 4' itemInput={c1s4} setItemInput={setC1s4} />
                                                    <FormInput label='Centre 1 Sud 5' itemInput={c1s5} setItemInput={setC1s5} />
                                                </div>

                                                { /******* Second Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Centre 2 Centre 1' itemInput={c2c1} setItemInput={setC2c1} />
                                                    <FormInput label='Centre 2 Centre 2' itemInput={c2c2} setItemInput={setC2c2} />
                                                    <FormInput label='Centre 2 Est 2' itemInput={c2e2} setItemInput={setC2e2} />
                                                    <FormInput label='Centre 2 Est 3' itemInput={c2e3} setItemInput={setC2e3} />
                                                    <FormInput label='Centre 2 Ouest 2' itemInput={c2o2} setItemInput={setC2o2} />
                                                    <FormInput label='Centre 2 Ouest 3' itemInput={c2o3} setItemInput={setC2o3} />
                                                    <FormInput label='Centre 2 Sud 4' itemInput={c2s4} setItemInput={setC2s4} />
                                                    <FormInput label='Centre 2 Sud 5' itemInput={c2s5} setItemInput={setC2s5} />
                                                </div>

                                                { /******* Third Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Est 2 Centre 1' itemInput={e2c1} setItemInput={setE2c1} />
                                                    <FormInput label='Est 2 Centre 2' itemInput={e2c2} setItemInput={setE2c2} />
                                                    <FormInput label='Est 2 Est 2' itemInput={e2e2} setItemInput={setE2e2} />
                                                    <FormInput label='Est 2 Est 3' itemInput={e2e3} setItemInput={setE2e3} />
                                                    <FormInput label='Est 2 Ouest 2' itemInput={e2o2} setItemInput={setE2o2} />
                                                    <FormInput label='Est 2 Ouest 3' itemInput={e2o3} setItemInput={setE2o3} />
                                                    <FormInput label='Est 2 Sud 4' itemInput={e2s4} setItemInput={setE2s4} />
                                                    <FormInput label='Est 2 Sud 5' itemInput={e2s5} setItemInput={setE2s5} />
                                                </div>

                                                { /******* Fourth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Est 3 Centre 1' itemInput={e3c1} setItemInput={setE3c1} />
                                                    <FormInput label='Est 3 Centre 2' itemInput={e3c2} setItemInput={setE3c2} />
                                                    <FormInput label='Est 3 Est 2' itemInput={e3e2} setItemInput={setE3e2} />
                                                    <FormInput label='Est 3 Est 3' itemInput={e3e3} setItemInput={setE3e3} />
                                                    <FormInput label='Est 3 Ouest 2' itemInput={e3o2} setItemInput={setE3o2} />
                                                    <FormInput label='Est 3 Ouest 3' itemInput={e3o3} setItemInput={setE3o3} />
                                                    <FormInput label='Est 3 Sud 4' itemInput={e3s4} setItemInput={setE3s4} />
                                                    <FormInput label='Est 3 Sud 5' itemInput={e3s5} setItemInput={setE3s5} />
                                                </div>

                                                { /******* Fifth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Ouest 2 Centre 1' itemInput={o2c1} setItemInput={setO2c1} />
                                                    <FormInput label='Ouest 2 Centre 2' itemInput={o2c2} setItemInput={setO2c2} />
                                                    <FormInput label='Ouest 2 Est 2' itemInput={o2e2} setItemInput={setO2e2} />
                                                    <FormInput label='Ouest 2 Est 3' itemInput={o2e3} setItemInput={setO2e3} />
                                                    <FormInput label='Ouest 2 Ouest 2' itemInput={o2o2} setItemInput={setO2o2} />
                                                    <FormInput label='Ouest 2 Ouest 3' itemInput={o2o3} setItemInput={setO2o3} />
                                                    <FormInput label='Ouest 2 Sud 4' itemInput={o2s4} setItemInput={setO2s4} />
                                                    <FormInput label='Ouest 2 Sud 5' itemInput={o2s5} setItemInput={setO2s5} />
                                                </div>

                                                { /******* Sixth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Ouest 3 Centre 1' itemInput={o3c1} setItemInput={setO3c1} />
                                                    <FormInput label='Ouest 3 Centre 2' itemInput={o3c2} setItemInput={setO3c2} />
                                                    <FormInput label='Ouest 3 Est 2' itemInput={o3e2} setItemInput={setO3e2} />
                                                    <FormInput label='Ouest 3 Est 3' itemInput={o3e3} setItemInput={setO3e3} />
                                                    <FormInput label='Ouest 3 Ouest 2' itemInput={o3o2} setItemInput={setO3o2} />
                                                    <FormInput label='Ouest 3 Ouest 3' itemInput={o3o3} setItemInput={setO3o3} />
                                                    <FormInput label='Ouest 3 Sud 4' itemInput={o3s4} setItemInput={setO3s4} />
                                                    <FormInput label='Ouest 3 Sud 5' itemInput={o3s5} setItemInput={setO3s5} />
                                                </div>

                                                { /******* Seventh Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Sud 4 Centre 1' itemInput={s4c1} setItemInput={setS4c1} />
                                                    <FormInput label='Sud 4 Centre 2' itemInput={s4c2} setItemInput={setS4c2} />
                                                    <FormInput label='Sud 4 Est 2' itemInput={s4e2} setItemInput={setS4e2} />
                                                    <FormInput label='Sud 4 Est 3' itemInput={s4e3} setItemInput={setS4e3} />
                                                    <FormInput label='Sud 4 Ouest 2' itemInput={s4o2} setItemInput={setS4o2} />
                                                    <FormInput label='Sud 4 Ouest 3' itemInput={s4o3} setItemInput={setS4o3} />
                                                    <FormInput label='Sud 4 Sud 4' itemInput={s4s4} setItemInput={setS4s4} />
                                                    <FormInput label='Sud 4 Sud 5' itemInput={s4s5} setItemInput={setS4s5} />
                                                </div>

                                                { /******* Eighth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Sud 5 Centre 1' itemInput={s5c1} setItemInput={setS5c1} />
                                                    <FormInput label='Sud 5 Centre 2' itemInput={s5c2} setItemInput={setS5c2} />
                                                    <FormInput label='Sud 5 Est 2' itemInput={s5e2} setItemInput={setS5e2} />
                                                    <FormInput label='Sud 5 Est 3' itemInput={s5e3} setItemInput={setS5e3} />
                                                    <FormInput label='Sud 5 Ouest 2' itemInput={s5o2} setItemInput={setS5o2} />
                                                    <FormInput label='Sud 5 Ouest 3' itemInput={s5o3} setItemInput={setS5o3} />
                                                    <FormInput label='Sud 5 Sud 4' itemInput={s5s4} setItemInput={setS5s4} />
                                                    <FormInput label='Sud 5 Sud 5' itemInput={s5s5} setItemInput={setS5s5} />
                                                </div>

                                                { /******* Ramassage Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Ram Zone 1' itemInput={ram1} setItemInput={setRam1} />
                                                    <FormInput label='Ram Zone 2' itemInput={ram2} setItemInput={setRam2} />
                                                    <FormInput label='Ram Zone 3' itemInput={ram3} setItemInput={setRam3} />
                                                    <FormInput label='Ram Zone 4' itemInput={ram4} setItemInput={setRam4} />
                                                    <FormInput label='Ram Zone 5' itemInput={ram5} setItemInput={setRam5} />
                                                </div>

                                                { /******* Depot Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Depot Zone 1' itemInput={depot1} setItemInput={setDepot1} />
                                                    <FormInput label='Depot Zone 2' itemInput={depot2} setItemInput={setDepot2} />
                                                    <FormInput label='Depot Zone 3' itemInput={depot3} setItemInput={setDepot3} />
                                                    <FormInput label='Depot Zone 4' itemInput={depot4} setItemInput={setDepot4} />
                                                    <FormInput label='Depot Zone 5' itemInput={depot5} setItemInput={setDepot5} />
                                                </div>

                                                { /******* Button to update *******/}
                                                <div className="button">
                                                    <span className='active' onClick={updateCostsHandler} style={isFetchingCostsUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                        {isFetchingCostsUpdate ? "Modifier ..." : "Modifier"}
                                                    </span>
                                                </div>
                                            </div>

                                            {/* Costs of Entreprises */}
                                            <div className={priceClientsAndEntreprises.id === 2 ? "filter-content deactive" : "filter-content"}>
                                                { /******* First Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Centre 1 Centre 1' itemInput={c1c1en} setItemInput={setC1c1En} />
                                                    <FormInput label='Centre 1 Centre 2' itemInput={c1c2en} setItemInput={setC1c2En} />
                                                    <FormInput label='Centre 1 Est 2' itemInput={c1e2en} setItemInput={setC1e2En} />
                                                    <FormInput label='Centre 1 Est 3' itemInput={c1e3en} setItemInput={setC1e3En} />
                                                    <FormInput label='Centre 1 Ouest 2' itemInput={c1o2en} setItemInput={setC1o2En} />
                                                    <FormInput label='Centre 1 Ouest 3' itemInput={c1o3en} setItemInput={setC1o3En} />
                                                    <FormInput label='Centre 1 Sud 4' itemInput={c1s4en} setItemInput={setC1s4En} />
                                                    <FormInput label='Centre 1 Sud 5' itemInput={c1s5en} setItemInput={setC1s5En} />
                                                </div>

                                                { /******* Second Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Centre 2 Centre 1' itemInput={c2c1en} setItemInput={setC2c1En} />
                                                    <FormInput label='Centre 2 Centre 2' itemInput={c2c2en} setItemInput={setC2c2En} />
                                                    <FormInput label='Centre 2 Est 2' itemInput={c2e2en} setItemInput={setC2e2En} />
                                                    <FormInput label='Centre 2 Est 3' itemInput={c2e3en} setItemInput={setC2e3En} />
                                                    <FormInput label='Centre 2 Ouest 2' itemInput={c2o2en} setItemInput={setC2o2En} />
                                                    <FormInput label='Centre 2 Ouest 3' itemInput={c2o3en} setItemInput={setC2o3En} />
                                                    <FormInput label='Centre 2 Sud 4' itemInput={c2s4en} setItemInput={setC2s4En} />
                                                    <FormInput label='Centre 2 Sud 5' itemInput={c2s5en} setItemInput={setC2s5En} />
                                                </div>

                                                { /******* Third Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Est 2 Centre 1' itemInput={e2c1en} setItemInput={setE2c1En} />
                                                    <FormInput label='Est 2 Centre 2' itemInput={e2c2en} setItemInput={setE2c2En} />
                                                    <FormInput label='Est 2 Est 2' itemInput={e2e2en} setItemInput={setE2e2En} />
                                                    <FormInput label='Est 2 Est 3' itemInput={e2e3en} setItemInput={setE2e3En} />
                                                    <FormInput label='Est 2 Ouest 2' itemInput={e2o2en} setItemInput={setE2o2En} />
                                                    <FormInput label='Est 2 Ouest 3' itemInput={e2o3en} setItemInput={setE2o3En} />
                                                    <FormInput label='Est 2 Sud 4' itemInput={e2s4en} setItemInput={setE2s4En} />
                                                    <FormInput label='Est 2 Sud 5' itemInput={e2s5en} setItemInput={setE2s5En} />
                                                </div>

                                                { /******* Fourth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Est 3 Centre 1' itemInput={e3c1en} setItemInput={setE3c1En} />
                                                    <FormInput label='Est 3 Centre 2' itemInput={e3c2en} setItemInput={setE3c2En} />
                                                    <FormInput label='Est 3 Est 2' itemInput={e3e2en} setItemInput={setE3e2En} />
                                                    <FormInput label='Est 3 Est 3' itemInput={e3e3en} setItemInput={setE3e3En} />
                                                    <FormInput label='Est 3 Ouest 2' itemInput={e3o2en} setItemInput={setE3o2En} />
                                                    <FormInput label='Est 3 Ouest 3' itemInput={e3o3en} setItemInput={setE3o3En} />
                                                    <FormInput label='Est 3 Sud 4' itemInput={e3s4en} setItemInput={setE3s4En} />
                                                    <FormInput label='Est 3 Sud 5' itemInput={e3s5en} setItemInput={setE3s5En} />
                                                </div>

                                                { /******* Fifth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Ouest 2 Centre 1' itemInput={o2c1en} setItemInput={setO2c1En} />
                                                    <FormInput label='Ouest 2 Centre 2' itemInput={o2c2en} setItemInput={setO2c2En} />
                                                    <FormInput label='Ouest 2 Est 2' itemInput={o2e2en} setItemInput={setO2e2En} />
                                                    <FormInput label='Ouest 2 Est 3' itemInput={o2e3en} setItemInput={setO2e3En} />
                                                    <FormInput label='Ouest 2 Ouest 2' itemInput={o2o2en} setItemInput={setO2o2En} />
                                                    <FormInput label='Ouest 2 Ouest 3' itemInput={o2o3en} setItemInput={setO2o3En} />
                                                    <FormInput label='Ouest 2 Sud 4' itemInput={o2s4en} setItemInput={setO2s4En} />
                                                    <FormInput label='Ouest 2 Sud 5' itemInput={o2s5en} setItemInput={setO2s5En} />
                                                </div>

                                                { /******* Sixth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Ouest 3 Centre 1' itemInput={o3c1en} setItemInput={setO3c1En} />
                                                    <FormInput label='Ouest 3 Centre 2' itemInput={o3c2en} setItemInput={setO3c2En} />
                                                    <FormInput label='Ouest 3 Est 2' itemInput={o3e2en} setItemInput={setO3e2En} />
                                                    <FormInput label='Ouest 3 Est 3' itemInput={o3e3en} setItemInput={setO3e3En} />
                                                    <FormInput label='Ouest 3 Ouest 2' itemInput={o3o2en} setItemInput={setO3o2En} />
                                                    <FormInput label='Ouest 3 Ouest 3' itemInput={o3o3en} setItemInput={setO3o3En} />
                                                    <FormInput label='Ouest 3 Sud 4' itemInput={o3s4en} setItemInput={setO3s4En} />
                                                    <FormInput label='Ouest 3 Sud 5' itemInput={o3s5en} setItemInput={setO3s5En} />
                                                </div>

                                                { /******* Seventh Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Sud 4 Centre 1' itemInput={s4c1en} setItemInput={setS4c1En} />
                                                    <FormInput label='Sud 4 Centre 2' itemInput={s4c2en} setItemInput={setS4c2En} />
                                                    <FormInput label='Sud 4 Est 2' itemInput={s4e2en} setItemInput={setS4e2En} />
                                                    <FormInput label='Sud 4 Est 3' itemInput={s4e3en} setItemInput={setS4e3En} />
                                                    <FormInput label='Sud 4 Ouest 2' itemInput={s4o2en} setItemInput={setS4o2En} />
                                                    <FormInput label='Sud 4 Ouest 3' itemInput={s4o3en} setItemInput={setS4o3En} />
                                                    <FormInput label='Sud 4 Sud 4' itemInput={s4s4en} setItemInput={setS4s4En} />
                                                    <FormInput label='Sud 4 Sud 5' itemInput={s4s5en} setItemInput={setS4s5En} />
                                                </div>

                                                { /******* Eighth Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Sud 5 Centre 1' itemInput={s5c1en} setItemInput={setS5c1En} />
                                                    <FormInput label='Sud 5 Centre 2' itemInput={s5c2en} setItemInput={setS5c2En} />
                                                    <FormInput label='Sud 5 Est 2' itemInput={s5e2en} setItemInput={setS5e2En} />
                                                    <FormInput label='Sud 5 Est 3' itemInput={s5e3en} setItemInput={setS5e3En} />
                                                    <FormInput label='Sud 5 Ouest 2' itemInput={s5o2en} setItemInput={setS5o2En} />
                                                    <FormInput label='Sud 5 Ouest 3' itemInput={s5o3en} setItemInput={setS5o3En} />
                                                    <FormInput label='Sud 5 Sud 4' itemInput={s5s4en} setItemInput={setS5s4En} />
                                                    <FormInput label='Sud 5 Sud 5' itemInput={s5s5en} setItemInput={setS5s5En} />
                                                </div>

                                                { /******* Ramassage Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Ram Zone 1' itemInput={ram1en} setItemInput={setRam1En} />
                                                    <FormInput label='Ram Zone 2' itemInput={ram2en} setItemInput={setRam2En} />
                                                    <FormInput label='Ram Zone 3' itemInput={ram3en} setItemInput={setRam3En} />
                                                    <FormInput label='Ram Zone 4' itemInput={ram4en} setItemInput={setRam4En} />
                                                    <FormInput label='Ram Zone 5' itemInput={ram5en} setItemInput={setRam5En} />
                                                </div>

                                                { /******* Depot Line *******/}
                                                <div className="side-to-side-cost">
                                                    <FormInput label='Depot Zone 1' itemInput={depot1en} setItemInput={setDepot1En} />
                                                    <FormInput label='Depot Zone 2' itemInput={depot2en} setItemInput={setDepot2En} />
                                                    <FormInput label='Depot Zone 3' itemInput={depot3en} setItemInput={setDepot3En} />
                                                    <FormInput label='Depot Zone 4' itemInput={depot4en} setItemInput={setDepot4En} />
                                                    <FormInput label='Depot Zone 5' itemInput={depot5en} setItemInput={setDepot5En} />
                                                </div>

                                                { /******* Button to update *******/}
                                                <div className="button">
                                                    <span className='active' onClick={updateCostsEntrepriseHandler} style={isFetchingCostsUpdate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                        {isFetchingCostsUpdate ? "Modifier ..." : "Modifier"}
                                                    </span>
                                                    {/* <span className='active'>Modifier</span> */}
                                                </div>
                                            </div>

                                        </div>

                                        <div className="content envoie">
                                            <div className='big-box'>
                                                <div className="box">
                                                    <div className="box-title">Type d'Envoie :</div>
                                                    <div className="box-content">
                                                        <FormRadio data={typeEnvois} itemChoisir={typeEnvoie} setItemChoisir={setTypeEnvoie} name='type-envoie' />
                                                    </div>
                                                </div>
                                                <div className="box">
                                                    <div className="box-title">Type Client :</div>
                                                    <div className="box-content">
                                                        <FormRadio data={clientsOrEntreprises} itemChoisir={typeClient} setItemChoisir={setTypeClient} name='type-client' />
                                                        {
                                                            typeClient.id === 1 && (
                                                                <DropDownComponent data={[{ nom: "Choisir Entreprise", id: 0, }, ...entreprisesMini]} itemChoisir={entreprise} setItemChoisir={setEntreprise} filter />
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='big-box'>
                                                {/*  Sender  */}
                                                <div className="box">
                                                    <div className="box-title">Expéditeur :</div>
                                                    <div className="box-content">
                                                        <DropDownComponent data={wilayas} itemChoisir={wilayaSender} setItemChoisir={setWilayaSender} />
                                                        <FormRadio data={typeRamassages} itemChoisir={typeRamassage} setItemChoisir={setTypeRamassage} name='type-ramassage' />
                                                    </div>
                                                </div>

                                                {/* Receiver */}
                                                <div className="box">
                                                    <div className="box-title">Destinataire :</div>
                                                    <div className="box-content">
                                                        <DropDownComponent data={wilayas} itemChoisir={wilayaReceiver} setItemChoisir={setWilayaReceiver} />
                                                        <FormRadio data={typeDeliveries} itemChoisir={typeDelivery} setItemChoisir={setTypeDelivery} name='type-delivery' />
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='big-box'>
                                                <div className="box">
                                                    <div className="box-title">Détails :</div>
                                                    <div className="box-content">
                                                        <FormInput label='Poids en KG *' itemInput={weight} setItemInput={setWeight} auth />
                                                    </div>
                                                </div>

                                                {
                                                    result !== "" && (
                                                        <div className="box">
                                                            <div className="box-title">Resultat :</div>
                                                            <div className="box-content">
                                                                <FormInput label='Cout en Dinars' itemInput={result} setItemInput={setResult} auth inactive />
                                                            </div>
                                                        </div>
                                                    )
                                                }
                                            </div>

                                            {/* <div className='button' onClick={handleGetCost}>
                                                <span className='add' style={isFetchingSimulate ? { cursor: 'not-allowed', pointerEvents: 'none' } : {}}>
                                                    {isFetchingSimulate ? "Simuler Prix ..." : "Simuler Prix"}
                                                </span>
                                            </div> */}

                                        </div>
                                    </>
                                )
                        )
                    )
                }
            </div>
        </div>
    )
}

export default Cost
